let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("hTb1M"), load("3UR1K"), load("4Oj5y")]).then(() => parcelRequire('2JKSZ'));